import {
  AngularFireDatabase,
} from 'angularfire2/database';
import { Component, OnInit, Input, NgZone, SimpleChanges, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from '../_services/user.service';
import { OnDestroy, OnChanges } from '@angular/core/src/metadata/lifecycle_hooks';
import { MediaMatcher } from '@angular/cdk/layout';
import { Subscription, Observable } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';
import { MetaService } from 'ng2-meta';
import { map } from 'rxjs/operators';
import { Http } from '@angular/http';

@Component({
  selector: "user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.css"]
})
export class UserProfileComponent implements OnInit, OnChanges, OnDestroy {
  @Input() profile: string;

  user: any;
  currentUser: any;
  userId = localStorage.getItem('currentUserId');
  followingPosts = [];
  following = [];
  myPosts;
  followers: number;
  @Input() brandName;
  uniqueName: string;
  userPostCount: Observable<any>;
  userRepostCount: Observable<any>;
  followCount: Observable<any>;
  followCountBrand: Observable<any>;
  followingCount: Observable<any>;
  type: string;
  followCounttypeBrand: any;
  postCount: number;
  ipAddress: any;
  isFollow = false;
  isPost = false;
  private subscription: Subscription = new Subscription();
  text = 'Exclusive Htc M10 Yeşilin 50 Tonu Des...';
  mobileQuery: any;
  subsc: Subscription = new Subscription();
  private _mobileQueryListener: () => void;

  constructor(private zone: NgZone,
    private media: MediaMatcher,
    private cd: ChangeDetectorRef,
    private afs: AngularFirestore,
    private route: ActivatedRoute,
    private router: Router,
    private _http: Http,
    private metaService: MetaService,
    private userService: UserService) {
    if (this.userId) {


      this.subscription.add(this.userService.getUser().subscribe(user => {

        this.currentUser = user;

      }));
    }
    this.mobileQuery = this.media.matchMedia('(max-width: 1025px)');
    this._mobileQueryListener = () => this.cd.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  goProducts(name, tag) {
    this.router.navigate(['/' + name], { queryParams: { tag: tag } });
  }

  ngOnChanges(changes: SimpleChanges) {

    this.subsc.unsubscribe();
    this.initialize();
  }

  ngOnInit() {
    this.initialize();
    this.getIpAdress();

  }
  // find_in_object(my_object){
  //   my_object.filter(a=> {
  //     if(a["reposts"] == null || undefined){
  //       return Object.keys(this.user.timeline);
  //     }
  //   })
  // }
  async initialize() {






    this.subscription.unsubscribe();
    this.subsc.unsubscribe();
    console.log();

    if (this.profile !== 'brand' && this.profile !== 'product' && this.userId) {

      this.subsc = this.afs.collection('users').doc(this.userId).valueChanges().subscribe(snap => {
        this.user = snap;
      });
      this.followCount = this.afs.collection('users').doc(this.userId).collection('followEr').valueChanges();

      this.followingCount = this.afs.collection('users').doc(this.userId).collection('followIng').valueChanges();


    }
    if (this.profile === 'brand') {
      this.subsc = new Subscription();
      this.subsc.add(this.afs.collection('posts', ref => ref.where('rating.uniqueName', '==', this.brandName)).valueChanges()
        .subscribe(data => {
          this.postCount = data.length;
        }));

      this.subscription = this.afs.collection('brands', ref => ref
        .where('uniqueName', '==', this.brandName)).snapshotChanges().pipe(map(actions => {
          return actions.map(data => {
            return {
              id: data.payload.doc.id,
              ...data.payload.doc.data()
            }
          })

        })).subscribe(snap => {
          this.user = snap[0];
          this.followCountBrand = this.afs.collection('brands').doc(snap[0].id).collection('followEr').valueChanges();

          this.subsc.add(this.followCountBrand.subscribe(data => {
            this.followCounttypeBrand = data.length;

          }));

          // this.followingCount = this.afs.collection('users').doc(snap[0].id).collection('followIng').valueChanges();
        });


      this.cd.markForCheck();






    }
    if (this.profile === 'product') {
      // this.postCount = this.afs.collection('posts', ref => ref.where('rating.uniqueName', '==', this.brandName)).valueChanges();

      this.subsc = await this.afs.collection('products', ref => ref.where('uniqueName', '==', this.brandName))
        .snapshotChanges().pipe(map(actions => {
          return actions.map(data => {
            return {
              id: data.payload.doc.id,
              ...data.payload.doc.data()
            };
          })
        })).subscribe(snap => {
          this.user = snap[0];
        })

      this.cd.markForCheck();

    }

    if ((this.profile === 'brand' && this.userId) || (this.profile === 'product' && this.userId)) {


      this.afs.collection('users').doc(this.userId).collection('followIng').ref
        .where('uniqueName', '==', this.brandName).get().then((data => {
          if (!data.empty) {
            this.isFollow = true;
          }
          else {
            this.isFollow = false;
          }
        }))
    }
  }
  getIpAdress() {
    this.subscription.add(this._http.get("https://api.bigadvice.com/helper/ip")
      .map(data => { this.ipAddress = data.json() }).subscribe());
  }


  async follow() {
    if (this.userId) {

      await this.afs.collection(this.profile + 's').doc(this.user.id).ref.get().then((snap => {
        this.afs.collection(this.profile + 's').doc(this.user.id)
          .update({ followErCount: this.user.followErCount ? this.user.followErCount + 1 : 1 }).then(() => {
            this.afs.collection('users').doc(this.userId).update({
              followIngCount: this.currentUser.followIngCount ? this.currentUser.followIngCount + 1 : 1

            });
          })
          .then(() => {
            this.afs.collection('users').doc(this.userId).collection('followIng').doc(this.user.id).set({
              name: snap.data().name,
              uniqueName: snap.data().uniqueName,
              profileImage: snap.data().profileImage ? snap.data().profileImage : "",
              type: this.profile,
              id: this.user.id

            });

          })
          .then(() => {
            this.afs.collection(this.profile + 's').doc(this.user.id).collection('followEr').doc(this.userId).set({
              firstname: this.currentUser.firstname,
              lastname: this.currentUser.lastname,
              email: this.currentUser.email ? this.currentUser.email : '',
              profileImage: this.currentUser.profileImage,
              username: this.currentUser.username,
              type: 'user',
              id: this.user.id
            })
            this.isFollow = true;
          }).then(() => {
            console.log("jjjj")
            this.userService.userLog('follow', this.ipAddress)
          })
      }))
    }
    else {
      this.zone.run(() => {
        this.router.navigate(['/auth']);
      });
    }
  }
  async unFollow() {
    this.isFollow = false;
    await this.afs.collection('users').doc(this.userId).update({
      followIngCount: this.currentUser.followIngCount ? this.currentUser.followIngCount - 1 : 0

    })
    await this.afs.collection(this.profile + 's').doc(this.user.id)
      .update({ followErCount: this.user.followErCount ? this.user.followErCount - 1 : 0 })
    await this.afs.collection('users').doc(this.userId).collection('followIng').doc(this.user.id).delete();
    await this.afs.collection(this.profile + 's').doc(this.user.id).collection('followEr').doc(this.userId).delete().then(() => {
      this.userService.userLog('unFollow', this.ipAddress)
    })

  }

  ngOnDestroy() {
    this.subsc.unsubscribe();
    this.subscription.unsubscribe();
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/user-profile/user-profile.component.ts